import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button, IconButton } from '@mui/material';

const AddButtonUI = (props) => {
  const { text, sx: sxProp, ...rest } = props;
  const Component = text ? Button : IconButton;
  const componentProps = text ? { startIcon: <AddIcon fontSize="small" /> } : {};
  const sx = {
    margin: '3px',
    color: 'white',
    backgroundColor: '#7d9eb0',
    '&.Mui-disabled': {
      color: 'action.disabled',
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: 'grey.400',
    },
    ...(text
      ? {
          padding: '2px 10px',
          minWidth: 0,
          textTransform: 'none',
          fontSize: 12,
          fontWeight: 600,
          borderRadius: '999px',
          '& .MuiButton-startIcon': {
            marginRight: 1,
          },
        }
      : {
          padding: '1px',
        }),

    ...sxProp,
  };

  return (
    <Component size="small" sx={sx} {...componentProps} {...rest}>
      {text ? text : <AddIcon fontSize="small" />}
    </Component>
  );
};

export default AddButtonUI;
